import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "introduction-to-composer"
    }}>{`Introduction to Composer`}</h1>
    <p>{`We use `}<a parentName="p" {...{
        "href": "https://getcomposer.org/"
      }}>{`Composer`}</a>{` to manage components and their dependencies. Using Composer to get the Adobe Commerce and Magento Open Source software metapackage provides the following advantages:`}</p>
    <ul>
      <li parentName="ul">{`Reuse third-party libraries without bundling them with source code`}</li>
      <li parentName="ul">{`Reduce extension conflicts and compatibility issues by using a component-based architecture with robust dependency management`}</li>
      <li parentName="ul">{`Adhere to `}<a parentName="li" {...{
          "href": "https://www.php-fig.org/"
        }}>{`PHP-Framework Interoperability Group (FIG)`}</a>{` standards`}</li>
      <li parentName="ul">{`Repackage the software with other components`}</li>
      <li parentName="ul">{`Use the software in a production environment`}</li>
    </ul>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`You can also `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/en/docs/commerce-operations/installation-guide/overview"
      }}>{`download`}</a>{` an archive file for a specific version of Adobe Commerce or Magento Open Source in either ZIP or TAR format. Installing the software from an archive lacks the advantages of using Composer. Contributing developers should use the `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/contributor/guides/install/"
      }}>{`git-based`}</a>{` installation method.`}</p>
    <h2 {...{
      "id": "links-to-code"
    }}>{`Links to code`}</h2>
    <p>{`The key to developing any component is its `}<a parentName="p" {...{
        "href": "https://getcomposer.org/doc/04-schema.md"
      }}><inlineCode parentName="a">{`composer.json`}</inlineCode></a>{` file, which specifies version and dependency information for a component, among other things. You can look at the code, such as:`}</p>
    <ul>
      <li parentName="ul">{`Metapackage, look at `}<inlineCode parentName="li">{`<magento_root>/composer.json`}</inlineCode>{`.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/magento/magento2/blob/2.4/app/code/Magento/Customer/composer.json"
        }}>{`Customer module`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/magento/magento2/blob/2.4/app/design/frontend/Magento/luma/composer.json"
        }}>{`Luma theme`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/magento/magento2/blob/2.4/app/i18n/Magento/en_US/composer.json"
        }}>{`en_us language package`}</a></li>
    </ul>
    <h2 {...{
      "id": "for-more-information"
    }}>{`For more information`}</h2>
    <p>{`For more information about Composer, see the `}<a parentName="p" {...{
        "href": "https://getcomposer.org/doc/00-intro.md"
      }}>{`Composer documentation`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      